
import { ModeloEditavel } from '@/dominio/editor/modelo/ModeloEditavel';
import { defineComponent } from 'vue';
import ModeloEdicao from './ModeloEdicao.vue';

export default defineComponent({
    name: 'AdicionarModelo',
    components: {
        ModeloEdicao,
    },
    props: {
        indice: { type: Number, required: true },
    },
    data() {
        return {
            emEdicao: false,
        };
    },
    methods: {
        editar() {
            this.emEdicao = true;
        },
        adicionarItem(modelo: ModeloEditavel) {
            this.emEdicao = false;
            this.$emit('adicionarItem', modelo);
        },
        cancelou() {
            this.emEdicao = false;
        },
    },
    emits: ['adicionarItem'],
});
